<template>
  <div id="app">
    <app-header/>
    <main class="pb-12">
      <div class="g-spacer pointer-events-none md:-mb-20 print:hidden"></div>
      <div class="h-fill fixed mt-graph lg:mt-17 top-0 left-0 transition-all duration-300 print:hidden">
        <graph/>
      </div>
      <div id="route">
        <router-view class="max-w-6xl mx-auto bg-white relative print:mt-8"/>
      </div>
    </main>
    <app-footer/>
  </div>
</template>

<script>
  import AppHeader from '@/components/AppHeader'
  import AppFooter from '@/components/AppFooter'
  const Graph = () => import(/* webpackChunkName: "graph" */ '@/components/Graph')

  export default {
    name: 'App',
    metaInfo () {
      const self = this
      return {
        titleTemplate (chunk) {
          return chunk ? `${chunk} - ${self.siteTitle}` : self.siteTitle
        }
      }
    },
    computed: {
      header () {
        return this.$store.state.header
      },
      siteTitle () {
        return this.header ? this.header.title : 'grundschule'
      }
    },
    mounted () {
      // focus actual content if not '/'
      const unwatch = this.$watch('$route.fullPath', (newVal) => {
        if (newVal === '/') return
        const headEl = document.getElementById('header')
        const routeEl = document.getElementById('route')
        const y = routeEl.offsetTop - headEl.clientHeight

        window.scrollTo(0, y)
        unwatch()
      })
    },
    components: { AppHeader, AppFooter, Graph }
  }
</script>

<style>
  @import './style/global.css';
</style>
